import React from 'react';
import { TableViewStore, BaseListViewStore } from "core/stores";
import {
    ConfirmingReportItemService,
} from "application/confirming-report/services";
import { action, observable } from "mobx";
import { resolveColumns } from "application/facility/util/resolveColumns";
import { ModalParams } from "core/models";

class ConfirmingReportItemListViewStore extends BaseListViewStore {
    @observable accessor counter = 0;
    constructor(rootStore) {
        const confirmingReportItemService = new ConfirmingReportItemService(
            rootStore.application.baasic.apiClient
        );

        const confirmingReportId = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            name: "confirming-report-item",
            routes: {
                pumpAndPoleItems: () => {
                    this.rootStore.routerStore.goTo(
                        'master.app.main.confirming-report.confirming-report-item.pump-and-pole-item.list',
                        { id: confirmingReportId }
                    );
                },
                specificConfirmingStatusItems: () => {
                    this.rootStore.routerStore.goTo(
                        'master.app.main.confirming-report.confirming-report-item.specific-confirming-status-item.list',
                        { id: confirmingReportId }
                    );
                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        if (this.counter === 0) {
                            params.orderBy = "salesOrderNumber";
                            params.orderDirection = "asc";
                            this.counter++;
                        }
                        const responseData =
                            await confirmingReportItemService.findGrouped({
                                ...params,
                                confirmingReportId,
                                embed: "confirmingReportItemValidations",
                                fields: "id,salesOrderNumber,facility,patientFullName,patientRemoteId,itemId,itemName,reference,confirmingReportItemValidations",
                            });
                        return responseData;
                    },
                };
            },
        });

        this.confirmingReportItemPreviewModal = new ModalParams({ onClose: null });
        this.confirmingReportItemValidationsModal = new ModalParams({ onClose: null });

        this.setTableStore(
            new TableViewStore(this.queryUtility, {
                columns: resolveColumns([
                    {
                        key: "salesOrderNumber",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.SALES_ORDER_NUMBER",
                        onClick: (item) => { this.openConfirmingReportItemPreviewModal(item.salesOrderNumber) },
                        width: 200
                    },
                    {
                        key: "facility",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.FACILITY",
                        onClick: (item) => { this.openConfirmingReportItemPreviewModal(item.salesOrderNumber) }
                    },
                    {
                        key: "patientRemoteId",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.PATIENT_ID",
                        onClick: (item) => { this.openConfirmingReportItemPreviewModal(item.salesOrderNumber) },
                        width: 200
                    },
                    {
                        key: "patientFullName",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.PATIENT_FULL_NAME",
                        onClick: (item) => { this.openConfirmingReportItemPreviewModal(item.salesOrderNumber) }
                    },
                    {
                        key: "reference",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.REFERENCE",
                        onClick: (item) => { this.openConfirmingReportItemPreviewModal(item.salesOrderNumber) }
                    },
                    {
                        key: "confirmingReportItemValidations",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.VALIDATIONS",
                        cell: (item) => this.renderValidationsCell(item),
                        headerClassName: 'center',
                        width: 150
                    },
                ]),
            })
        );
    }

    @action.bound
    openConfirmingReportItemPreviewModal(salesOrderNumber) {
        const confirmingReportId = this.rootStore.routerStore.routerState.params.id;
        this.confirmingReportItemPreviewModal.open({
            confirmingReportId,
            salesOrderNumber
        });
    }

    @action.bound
    openConfirmingReportItemValidationsModal(item) {
        const confirmingReportId = this.rootStore.routerStore.routerState.params.id;
        const salesOrderNumber = item.salesOrderNumber;
        const patientFullName = item.patientFullName;
        this.confirmingReportItemValidationsModal.open({
            confirmingReportId,
            salesOrderNumber,
            patientFullName,
            fetchTable: this.queryUtility.fetch
        });
    }

    @action.bound
    renderValidationsCell(item) {
        const confirmingReportItemValidations = item.dataItem.confirmingReportItemValidations;
        const isValidationFailed = confirmingReportItemValidations.some(itemValidation => !itemValidation.isResolved);
        let validationMessages = [];
        validationMessages.push("Failed Validations: \n");

        confirmingReportItemValidations.forEach(itemValidation => {
            if (itemValidation.isResolved === false)
                validationMessages.push(`${itemValidation.validation.name} \n`);
        });

        return (
            <React.Fragment>
                {
                    confirmingReportItemValidations.length > 0 ?
                    <td className="c-pointer table--clickable table__body--data left" onClick={() => this.openConfirmingReportItemValidationsModal(item.dataItem)}>
                        <div className="type--center">
                            {
                                !isValidationFailed ? <i className="u-icon u-icon--sml u-icon--active"></i> :
                                    <i title={validationMessages.join("")} className="u-icon u-icon--sml u-icon--inactive"></i>
                            }
                        </div>
                    </td>
                    :
                    <td className="table__body--data left">
                    </td>
                }
            </React.Fragment>
        );
    }
}

export default ConfirmingReportItemListViewStore;
